/**
 * Query Parameters Control Component
 * 
 * Controls display based on URL query parameters
 * 
 * @package TopBuddy
 */

import { ToggleControl, TextControl, Button } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { plus, trash } from '@wordpress/icons';
import ProBadge from '../ProBadge';

const QueryParametersControl = ({ enabled, params = [], onEnabledChange, onParamsChange }) => {
	const postSettingsData = window.topbuddyPostSettings || {};
	const isProActive = postSettingsData.isProActive || false;
	const upgradeUrl = postSettingsData.upgradeUrl || 'https://wptopbuddy.com/?utm_source=plugin&utm_medium=topbuddy-free-plugin&utm_campaign=topbuddy-free-plugin-admin';

	const addParam = () => {
		onParamsChange([...params, { name: '', value: '' }]);
	};

	const removeParam = (index) => {
		const newParams = params.filter((_, i) => i !== index);
		onParamsChange(newParams);
	};

	const updateParam = (index, field, value) => {
		const newParams = [...params];
		newParams[index] = { ...newParams[index], [field]: value };
		onParamsChange(newParams);
	};

	return (
		<div className="topbuddy-display-rules__field">
			<ToggleControl
				label={
					<>
						{__('Query Parameters', 'topbuddy')}
						{!isProActive && <ProBadge upgradeUrl={upgradeUrl} />}
					</>
				}
				help={__('Show notification only when URL contains these query parameters (all must match)', 'topbuddy')}
				checked={enabled}
				onChange={onEnabledChange}
				disabled={!isProActive}
				__nextHasNoMarginBottom
			/>
			
			{enabled && isProActive && (
				<div className="topbuddy-query-params">
					{params.map((param, index) => (
						<div key={index} className="topbuddy-query-param-row" style={{ display: 'flex', gap: '8px', marginBottom: '8px', alignItems: 'flex-start' }}>
							<TextControl
								placeholder={__('Parameter name (e.g., utm_source)', 'topbuddy')}
								value={param.name}
								onChange={(value) => updateParam(index, 'name', value)}
								style={{ flex: 1 }}
								__next40pxDefaultSize
								__nextHasNoMarginBottom
							/>
							<TextControl
								placeholder={__('Parameter value (e.g., facebook)', 'topbuddy')}
								value={param.value}
								onChange={(value) => updateParam(index, 'value', value)}
								style={{ flex: 1 }}
								__next40pxDefaultSize
								__nextHasNoMarginBottom
							/>
							<Button
								icon={trash}
								label={__('Remove parameter', 'topbuddy')}
								onClick={() => removeParam(index)}
								isDestructive
								style={{ marginTop: '3px' }}
							/>
						</div>
					))}
					<Button
						icon={plus}
						variant="secondary"
						onClick={addParam}
						style={{ marginTop: '8px' }}
					>
						{__('Add Parameter', 'topbuddy')}
					</Button>
					<p className="components-base-control__help" style={{ marginTop: '8px', marginBottom: 0 }}>
						{__('All parameters must match for the notification to show. Leave value empty to match any value for that parameter name.', 'topbuddy')}
					</p>
				</div>
			)}
		</div>
	);
};

export default QueryParametersControl;
